import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { Button } from "../../assets/libraries/bootstrap/js/bootstrap";
import { api } from "../../utils/Api";
import FileAlert from "../Company/FileAlert";
import NoteAlert from "../Company/NoteAlert";
import EditorAlert from "./EditorAlert";
import RejectAlert from "./RejectAlert";
import moment from "moment";
import { DateRange, extendMoment } from "moment-range";

import Countdown from "react-countdown";
import toast from "react-hot-toast";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

// const active_task = {};

export default function company(props: any) {
  const [active_task, SetActiveTask] = useState([]);
  const [assign_task, SetAssignTask] = useState([]);
  const [history, SetHistory] = useState(Boolean);

  const [data, SetData] = useState([]);
  const [historyData, SetHistoryData] = useState([]);

  const [formData, setFormData] = useState({});
  const [company, setCompany] = useState({});
  const [company_id, setCompanyId] = useState({});
  const [next_page, SetNextPage] = useState(false);
  const [page_no, SetPageNo] = useState(1);
  const [historyVal, SetHistoryVal] = useState([]);
  const [curr_time, SetCurrentTime] = useState({});

  const [finish_note, SetFinishNote] = useState();

  //   const [now, SetNow] = useState([]);

  // SetNow(moment())

  const [file_modal, SetFileModal] = useState({
    is_open: false,
    title: "",
    record: [],
    index: "",
  });

  const [note_modal, SetNoteModal] = useState({
    is_open: false,
    title: "",
    record: [],
    index: "",
  });

  const [editor_modal, SetEditorModal] = useState({
    is_open: false,
    title: "",
    record: [],
    index: "",
  });

  const [reject_modal, SetRejectModal] = useState({
    is_open: false,
    title: "",
    record: {},
    assign_task: [],
    index: "",
  });

  const [company_data, SetCompanyData] = useState([]);

  const [filter_data, SetFilterData] = useState({
    selected_company: { label: "All", value: "all" },
    search_value: "",
  });

  const [timer, SetTimer] = useState(null);
  const WAIT_INTERVAL = 700;

  function input_on_changes(event: any) {
    console.log("input_on_change value", event.target.value);
    console.log("input_on_change value", event.target.name);

    let key_name = event.target.name;
    let key_value = event.target.value;

    setFormData((prevState) => {
      // ...prevState,
      prevState[key_name] = key_value;
      return { ...prevState };
    });
    console.log(formData);
  }

  async function get_submitFinishForm(id: any) {
    console.log(id);

    var post_data: any = formData;
    console.log("post_data:", post_data);

    post_data.task_id = id;

    console.log("formData :", formData);
    let pass_data = {
      post: post_data,
    };

    let data = await api("/company/finish_task_work", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      let pathname = window.location.pathname;
      let company_id = pathname.replace("/company/", "");

      get_Assign_task(company_id, false, 1);
    }

    console.log("pass_data :", pass_data);
  }

  async function get_submitSellForm(id: any) {
    console.log(id);

    var post_data: any = formData;
    console.log("post_data:", post_data);

    post_data.task_id = id;

    console.log("formData :", formData);
    let pass_data = {
      post: post_data,
    };

    let data = await api("/company/pause_task_work", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      let pathname = window.location.pathname;
      let company_id = pathname.replace("/company/", "");

      get_Assign_task(company_id, false, 1);
    }

    console.log("pass_data :", pass_data);
  }

  async function get_Assign_task(
    props: any,
    next_page_value = false,
    page_no_value: any
  ) {
    console.log(props);
    setCompanyId(props);
    console.log("page_no_value :", page_no_value);

    let pass_data: any = {
      get: {
        company_id: props,
        page: page_no_value,
      },
    };

    if (filter_data.selected_company.value != "all") {
      pass_data.get.filter_company = filter_data.selected_company.value;
    }

    if (filter_data.search_value != "") {
      pass_data.get.search = filter_data.search_value;
    }

    let response = await api("/company/assigned_tasks", pass_data);
    console.log("/company/assigned_tasks :", response.response);
    if (response.response.hasOwnProperty("current_working")) {
      SetActiveTask(response.response.current_working);
    } else {
      SetActiveTask([]);
    }

    SetData(response.response);
    setCompany(response.response.company_details);

    if (response.response.hasOwnProperty("filter_company")) {
      response.response.filter_company.map((ele) => {
        ele.label = ele.name;
        ele.value = ele.id;
      });
      response.response.filter_company.push({ label: "All", value: "all" });
      SetCompanyData(response.response.filter_company);
    }

    if (response.response.hasOwnProperty("data")) {
      console.log("qewrty");
      SetAssignTask((prevValue) => {
        console.log(next_page_value);
        console.log(prevValue);
        if (next_page_value) {
          for (let i = 0; i < response.response.data.length; i++) {
            prevValue.push(response.response.data[i]);
          }
        } else {
          prevValue = response.response.data;
        }
        return [...prevValue];
      });
    } else {
      console.log("qewrty :[]");

      SetAssignTask([]);
    }

    if (response.response.next_page) {
      SetPageNo(page_no_value + 1);

      SetNextPage(true);
    } else {
      SetNextPage(false);
    }
  }

  async function get_history(props) {
    let history_val = historyVal;
    console.log(historyVal);
    let pass_data: any = {
      get: {
        company_id: props,
        page: page_no,
      },
    };

    if (history) {
      pass_data.get.history = true;
    }

    console.log("pass_data :", pass_data);

    let response = await api("/company/assigned_tasks", pass_data);

    console.log("job_invitations response :", response.response.data);
    // setInvitition(response.response.data);
    SetHistoryVal(response.response.data);

    if (response.response.data) {
      for (let i = 0; i < response.response.data.length; i++) {
        history_val.push(response.response.data[i]);
      }
    }

    SetHistoryVal(history_val);

    if (response.response.next_page) {
      SetPageNo(page_no + 1);
      SetNextPage(true);
    } else {
      SetNextPage(false);
    }
  }

  async function start(props) {
    //     // }
    console.log(props);

    let pass_data = {
      post: {
        task_id: props,
      },
    };
    let response = await api("/company/start_task_work", pass_data);
    console.log("app_init :", response.status_code);

    if (response.status_code == 200) {
      let pathname = window.location.pathname;
      let company_id = pathname.replace("/company/", "");
      SetPageNo(1);
      SetAssignTask([]);
      get_Assign_task(company_id, false, 1);
    }
  }

  async function pause(props) {
    //     // }
    console.log(props);

    let pass_data = {
      post: {
        task_id: props,
      },
    };
    let response = await api("/company/start_task_work", pass_data);
    console.log("app_init :", response.status_code);

    if (response.status_code == 200) {
      let pathname = window.location.pathname;
      let company_id = pathname.replace("/company/", "");

      get_Assign_task(company_id, false, 1);
    }
  }

  async function accept_invite(item: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: item.id,
      },
    };
    let data = await api("/company/accept_job_invitation", pass_data);
    console.log(assign_task);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let pathname = window.location.pathname;
      // let company_id = pathname.replace("/company/", "");
      // SetAssignTask([]);

      // get_Assign_task(company_id, false, 1);

      if (data.response.hasOwnProperty("message")) {
        toast.error(data.response.message);
      } else {
        let assign_task_value = assign_task;
        let index = assign_task_value.indexOf(item);
        console.log(index);
        assign_task_value[index].invitation_status = "Accepted";
        console.log(assign_task_value);
        SetAssignTask([...assign_task_value]);
        console.log("assign_task", assign_task);
      }
    }
  }

  async function reject_invite(record: any, index: any, at: any) {
    let pass_data = {
      post: {
        invitation_id: record.id,
      },
    };

    // console.log(at);
    let data = await api("/company/reject_job_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let assign_task_value = at;
      // let index_reject = assign_task_value.indexOf(record);
      // console.log(index);
      console.log("assign_task bf  at:", at);
      at.splice(index, 1);
      console.log("assign_task af  at:", at);
      SetAssignTask((old_value) => {
        old_value = at;
        return [...old_value];
      });

      // assign_task_value.splice(index_reject, 1);
      // console.log(assign_task_value);
      // SetAssignTask(assign_task_value);
      // console.log("assign_task", assign_task);
    }
  }

  useEffect(() => {
    console.log("Activity On mount :", props);
    console.log("componentDidMount ViewPost :", window.location);
    let pathname = window.location.pathname;
    let company_id = pathname.replace("/company/", "");
    console.log("company_id :", company_id);
    get_Assign_task(company_id, false, 1);
    if (history) {
      get_history(company_id);
    }
  }, [history]);

  useEffect(() => {
    console.log("assign_task On change :", assign_task);
  }, [assign_task]);

  useEffect(() => {
    console.log("company On mount :");
    Current();
  }, []);

  function move(i: any) {
    let selected_data = active_data[i];
    console.log(selected_data);
    SetActiveTask(selected_data);
    SetActiveData((preval) => {
      preval.splice(i, 1);

      preval.push(active_task);

      return [...preval];
    });
  }

  // function reject(i: any) {
  //   SetActiveData((preval) => {
  //     preval.splice(i, 1);

  //     return [...preval];
  //   });
  // }

  function finish() {
    SetActiveTask("");
  }

  // function pause(i: any) {

  //   {active_task.started="t"}
  //   SetActiveData((preval) => {
  //     preval.push(active_task);

  //     return [...preval];
  //   });

  //   SetActiveTask("");
  // }

  // {console.log(active_data)}

  function secondsToHms(d) {
    // d = Number(d);

    // var h = Math.floor(d / 3600);
    // var m = Math.floor((d % 3600) / 60);
    // var s = Math.floor((d % 3600) % 60);

    // return (
    //   ("0" + h).slice(-2) +
    //   ":" +
    //   ("0" + Math.abs(m)).slice(-2) +
    //   ":" +
    //   ("0" + Math.abs(s)).slice(-2)
    // );

    let sec_num = parseInt(d, 10);
    let hours = parseInt(sec_num / 3600);
    let minutes = parseInt((sec_num - hours * 3600) / 60);

    return hours + ":" + Math.abs(minutes);
  }

  function Current() {
    var currentDateTime = new Date();
    var resultInSeconds = currentDateTime.getTime() / 1000;
    console.log("resultInSeconds :", resultInSeconds);
    SetCurrentTime(resultInSeconds);
  }

  function onTextChanged(e: any) {
    clearTimeout(timer);
    const value = e.target.value;
    console.log("Text onchange: ", value);

    SetFilterData((prevValue) => {
      prevValue.search_value = value;
      if (value == "") {
        // get_orders(prevValue);
        get_Assign_task(company_id, false, 1);
      } else {
        SetTimer(
          setTimeout(() => {
            // get_orders(prevValue);
            get_Assign_task(company_id, false, 1);
          }, WAIT_INTERVAL)
        );
      }
      return { ...prevValue };
    });
  }

  return (
    <div>
      <div className="bg-white mb-3 pt-5">
        <div className="container">
          <div className="row">
            <div className="col-10">
              <h5>{company.name}</h5>
              {console.log(curr_time)}
              <h5 className="text-muted">{company.app_name}</h5>
            </div>

            <div className="col">
              <Link
                className="text-decoration-none text-dark text-decoration-color: black col-10"
                to={"/work_invite/" + company.id + "/all"}
              >
                {/* </Link> */}
                <button className="btn btn-primary btn-sm px-3">
                  Work Invite
                </button>
              </Link>
            </div>
          </div>

          {/* {assign_task ? ( */}

          <nav className="pt-1 sticky-tabs">
            <div className="nav nav-tabs " id="nav-tab" role="tablist">
              <button
                className="nav-link active"
                id="active-users-tab"
                data-bs-toggle="tab"
                data-bs-target="#active-users"
                type="button"
                role="tab"
                aria-controls="active-users"
                aria-selected="true"
                onClick={() => {
                  SetHistory(false);
                  SetPageNo(1);
                  SetAssignTask([]);
                }}
              >
                Active
              </button>

              <button
                className="nav-link"
                id="deleted-users-tab"
                data-bs-toggle="tab"
                data-bs-target="#history-tasks"
                type="button"
                role="tab"
                aria-controls="deleted-users"
                aria-selected="false"
                onClick={() => {
                  SetHistory(true);
                  SetPageNo(1);
                  SetHistoryVal([]);
                }}
              >
                History
              </button>
            </div>
          </nav>
        </div>
      </div>
      <div className="tab-content" id="nav-tabContent">
        <div
          className="tab-pane fade show active"
          id="active-users"
          role="tabpanel"
          aria-labelledby="active-users-tab"
        >
          <div className="container">
            <div className="row">
              <>
                <div className="col-lg-6 p-2">
                  {active_task.length > 0 ? (
                    active_task?.map((item: any, index: any) =>
                      item.app_id == 2 ? (
                        <div className="card mb-3">
                          <div className="card-body">
                            {/* <h5 className="card-title"> {item.company}</h5> */}
                            {/* <h6 className="card-subtitle mb-2 text-muted">Card subtitle</h6> */}
                            <div>
                              <h5 className="mb-3">Ongoing Work</h5>

                              <div className="card-text ">
                                <div className="d-flex">
                                  <div>
                                    <div className="f-14">
                                      {item.service_name}
                                    </div>

                                    <div>
                                      <h6>{item.event_name}</h6>
                                    </div>

                                    {item.event_starts && (
                                      <p className="text-muted">
                                        <i className="fa-regular fa-clock"></i>{" "}
                                        {item.event_starts} to {item.event_ends}
                                      </p>
                                    )}
                                    {/* <h5>({item.quantity})</h5> */}

                                    {item.event_venue && (
                                      <div>Venue: {item.event_venue}</div>
                                    )}
                                    {item.event_location && (
                                      <div>
                                        <i className="fa-solid fa-location-dot"></i>{" "}
                                        {item.event_location}
                                      </div>
                                    )}

                                    {item.client_name && (
                                      <h6>Client Name : {item.client_name}</h6>
                                    )}
                                  </div>

                                  {item.event_latitude &&
                                  item.event_longitude ? (
                                    <div className="ms-lg-auto">
                                      <div className="text-center">
                                        <a
                                          target="_blank"
                                          href={
                                            "https://www.google.com/maps/search/?api=1&query=" +
                                            item.event_latitude +
                                            "%2C" +
                                            item.event_longitude
                                          }
                                        >
                                          <i className="fas fa-directions fs-38"></i>
                                          <div className="text-uppercase mt-1 fs-12">
                                            Get Directions
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>

                                <div>Exposure pay : {item.amount}</div>
                                <div className="text-muted">
                                  {moment(item.created_at).fromNow()}
                                </div>
                                {item.hasOwnProperty("rework_message") ? (
                                  <div>
                                    <h4>Rework</h4>
                                    <p>
                                      Rework Message : {item.rework_message}
                                    </p>
                                  </div>
                                ) : null}

                                {item.hasOwnProperty("rework_salary_amount") ? (
                                  <div>
                                    <p>
                                      Rework Salary Amount :{" "}
                                      {item.rework_salary_amount}
                                    </p>
                                  </div>
                                ) : null}

                                <div className="float-end">
                                  <button
                                    type="button"
                                    className="btn btn-success btn-m-2 btn-sm px-3"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal1"
                                  >
                                    Finish
                                  </button>
                                  {/* <!-- Modal --> */}
                                  <div
                                    className="modal fade"
                                    id="exampleModal1"
                                    tabindex="-1"
                                    aria-labelledby="exampleModalLabel"
                                    aria-hidden="true"
                                  >
                                    <div className="modal-dialog">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5
                                            className="modal-title"
                                            id="exampleModalLabel"
                                          >
                                            Finish Work{" "}
                                          </h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                          ></button>
                                        </div>
                                        <div className="modal-body">
                                          Are you sure want to finish ongoing
                                          task ?
                                        </div>
                                        <div className="modal-footer">
                                          <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal"
                                          >
                                            Close
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-primary"
                                            data-bs-dismiss="modal"
                                            onClick={() => {
                                              console.log("hgfd", formData);
                                              get_submitFinishForm(item.id);
                                            }}
                                          >
                                            Finish
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="card mb-3">
                          <div className="card-body">
                            <div className="container">
                              <div className="row">
                                <div className="card-text p-2">
                                  <div className="d-flex">
                                    <h5 className="mb-3">Ongoing Work</h5>
                                    <div className="dropdown ms-auto">
                                      <div
                                        id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa-solid fa-ellipsis"></i>
                                      </div>
                                      <ul
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton1"
                                      >
                                        <li>
                                          <a
                                            className="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                              // delete_service(data, s_index);
                                              SetFileModal((prevValue) => {
                                                prevValue.is_open = true;
                                                prevValue.title = "Files";
                                                prevValue.record =
                                                  item.hasOwnProperty("files")
                                                    ? item.files
                                                    : [];
                                                prevValue.index = index;
                                                return { ...prevValue };
                                              });
                                            }}
                                          >
                                            Files
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            className="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                              // delete_service(data, s_index);
                                              SetEditorModal((prevValue) => {
                                                prevValue.is_open = true;
                                                prevValue.title =
                                                  "Editor field";
                                                prevValue.record =
                                                  item.hasOwnProperty(
                                                    "edited_files"
                                                  )
                                                    ? item.edited_files
                                                    : [];
                                                prevValue.index = index;
                                                return { ...prevValue };
                                              });
                                            }}
                                          >
                                            Editor field
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            className="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                              // delete_service(data, s_index);
                                              SetNoteModal((prevValue) => {
                                                prevValue.is_open = true;
                                                prevValue.title = "Notes";
                                                prevValue.record =
                                                  item.hasOwnProperty("notes")
                                                    ? item.notes
                                                    : [];
                                                prevValue.index = index;
                                                return { ...prevValue };
                                              });
                                            }}
                                          >
                                            Notes
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="d-flex">
                                    <div>
                                      <h6>{item.task}</h6>
                                      <h6 className="text-muted">
                                        Service : {item.service_name}
                                      </h6>
                                    </div>
                                    <div className="ms-auto text-center">
                                      <div className="d-flex">
                                        <div className="fs-14">
                                          {item.quantity}
                                        </div>
                                        <div className="ms-1">Qty</div>
                                      </div>
                                      {item.max_working_hours && (
                                        <div>
                                          max time :{item.max_working_hours} hrs
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <h6>{item.event_name}</h6>
                                  <h6>Customer : {item.customer_name}</h6>

                                  <h6>File Name : {item.client_name}</h6>

                                  <div className="text-muted mb-2">
                                    {item.created_at}
                                  </div>
                                  <div className="d-flex">
                                    <div>
                                      {" "}
                                      <Countdown
                                        date={
                                          Date.now() +
                                          item.remaining_duration * 1000
                                        }
                                      />
                                    </div>
                                    <div className="ms-auto">
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm px-3"
                                          data-bs-toggle="modal"
                                          data-bs-target="#exampleModal"
                                        >
                                          Pause
                                        </button>
                                        {/* <!-- Modal --> */}
                                        <div
                                          className="modal fade"
                                          id="exampleModal"
                                          tabindex="-1"
                                          aria-labelledby="exampleModalLabel"
                                          aria-hidden="true"
                                        >
                                          <div className="modal-dialog">
                                            <div className="modal-content">
                                              <div className="modal-header">
                                                <h5
                                                  className="modal-title"
                                                  id="exampleModalLabel"
                                                >
                                                  Pause Work
                                                </h5>
                                                <button
                                                  type="button"
                                                  className="btn-close"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                ></button>
                                              </div>
                                              <div className="modal-body">
                                                <p>Reason</p>
                                                <div className="description">
                                                  <textarea
                                                    onChange={(event) => {
                                                      input_on_changes(event);
                                                    }}
                                                    name="reason"
                                                    className="form-control"
                                                    id="exampleFormControlTextarea1"
                                                    rows="3"
                                                  ></textarea>
                                                </div>

                                                <br></br>
                                                <p>Quantity </p>
                                                <input
                                                  className="form-control"
                                                  onChange={(event) => {
                                                    input_on_changes(event);
                                                  }}
                                                  name="quantity"
                                                  type="text"
                                                  placeholder=""
                                                />
                                                <br></br>

                                                <p>File Path</p>
                                                <input
                                                  className="form-control"
                                                  onChange={(event) => {
                                                    input_on_changes(event);
                                                  }}
                                                  name="file_path"
                                                  type="text"
                                                  placeholder=""
                                                />
                                              </div>
                                              <div className="modal-footer">
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary"
                                                  data-bs-dismiss="modal"
                                                >
                                                  Close
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  data-bs-dismiss="modal"
                                                  onClick={() => {
                                                    console.log(
                                                      "hgfd",
                                                      formData
                                                    );
                                                    get_submitSellForm(item.id);
                                                  }}
                                                >
                                                  Save changes
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        &nbsp;
                                        <button
                                          type="button"
                                          className="btn btn-success btn-m-2 btn-sm px-3"
                                          data-bs-toggle="modal"
                                          data-bs-target="#exampleModal1"
                                        >
                                          Finish
                                        </button>
                                        {/* <!-- Modal --> */}
                                        <div
                                          className="modal fade"
                                          id="exampleModal1"
                                          tabindex="-1"
                                          aria-labelledby="exampleModalLabel"
                                          aria-hidden="true"
                                        >
                                          <div className="modal-dialog">
                                            <div className="modal-content">
                                              <div className="modal-header">
                                                <h5
                                                  className="modal-title"
                                                  id="exampleModalLabel"
                                                >
                                                  Finish Work{" "}
                                                </h5>
                                                <button
                                                  type="button"
                                                  className="btn-close"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                ></button>
                                              </div>
                                              <div className="modal-body">
                                                <p>Quantity </p>
                                                <input
                                                  className="form-control"
                                                  onChange={(event) => {
                                                    input_on_changes(event);
                                                  }}
                                                  name="quantity"
                                                  type="text"
                                                  placeholder=""
                                                />
                                                <br></br>

                                                <p>File Path</p>
                                                <input
                                                  className="form-control"
                                                  onChange={(event) => {
                                                    input_on_changes(event);
                                                  }}
                                                  name="file_path"
                                                  type="text"
                                                  placeholder=""
                                                />
                                                <br></br>
                                                <div className="">
                                                  <p>Notes</p>
                                                  <textarea
                                                    name="notes"
                                                    type="text"
                                                    placeholder="Review"
                                                    onChange={(event) => {
                                                      input_on_changes(event);
                                                    }}
                                                  ></textarea>
                                                </div>
                                              </div>
                                              <div className="modal-footer">
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary"
                                                  data-bs-dismiss="modal"
                                                >
                                                  Close
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  data-bs-dismiss="modal"
                                                  onClick={() => {
                                                    console.log(
                                                      "hgfd",
                                                      formData
                                                    );
                                                    get_submitFinishForm(
                                                      item.id
                                                    );
                                                  }}
                                                >
                                                  Finish
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div
                      className="card d-flex align-items-center justify-content-center"
                      style={{ minWidth: "18rem", minHeight: "16rem" }}
                    >
                      <p>No Ongoing task</p>
                    </div>
                  )}
                </div>

                <div className="col-lg-6 p-2 overflow-auto">
                  <div className="d-flex">
                    <Select
                      components={animatedComponents}
                      placeholder="Select Customer"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={company_data}
                      onChange={(e) => {
                        // set("system_roles", e, e);
                        SetFilterData((prevValue) => {
                          prevValue.selected_company = e;
                          return { ...prevValue };
                        });
                        get_Assign_task(company_id, false, 1);
                      }}
                    />
                    <input
                      className="ms-3"
                      value={filter_data.search_value}
                      placeholder="Search Customer / File Name"
                      onChange={(e) => {
                        onTextChanged(e);
                      }}
                    />
                  </div>
                  {assign_task.length > 0
                    ? assign_task.map(
                        (item: any, index: any) =>
                          item.task_status != "Working" && (
                            <div className="card m-2 ">
                              {item.company_name != null ? (
                                <div>
                                  {item.app_id == 2 ? (
                                    <div className="card-body">
                                      {/* <h5 className="card-title"> {item.company}</h5> */}
                                      {/* <h6 className="card-subtitle mb-2 text-muted">Card subtitle</h6> */}
                                      <div>
                                        <div className="card-text ">
                                          <div className="d-flex">
                                            <div>
                                              <div className="f-14">
                                                {item.service_name}
                                              </div>

                                              <div>
                                                <h6>{item.event_name}</h6>
                                              </div>

                                              {item.event_starts && (
                                                <p className="text-muted">
                                                  <i className="fa-regular fa-clock"></i>{" "}
                                                  {item.event_starts} to{" "}
                                                  {item.event_ends}
                                                </p>
                                              )}
                                              {/* <h5>({item.quantity})</h5> */}
                                              {item.event_venue && (
                                                <div>
                                                  Venue: {item.event_venue}
                                                </div>
                                              )}
                                              {item.event_location && (
                                                <div>
                                                  <i className="fa-solid fa-location-dot"></i>{" "}
                                                  {item.event_location}
                                                </div>
                                              )}
                                              {item.client_name && (
                                                <h6>
                                                  Client Name :{" "}
                                                  {item.client_name}
                                                </h6>
                                              )}
                                            </div>

                                            {item.event_latitude &&
                                            item.event_longitude ? (
                                              <div className="ms-lg-auto">
                                                <div className="text-center">
                                                  <a
                                                    target="_blank"
                                                    href={
                                                      "https://www.google.com/maps/search/?api=1&query=" +
                                                      item.event_latitude +
                                                      "%2C" +
                                                      item.event_longitude
                                                    }
                                                  >
                                                    <i className="fas fa-directions fs-38"></i>
                                                    <div className="text-uppercase mt-1 fs-12">
                                                      Get Directions
                                                    </div>
                                                  </a>
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>

                                          <div>
                                            Exposure pay : {item.amount}
                                          </div>
                                          <div className="text-muted">
                                            {item.created_at}
                                          </div>
                                          {item.hasOwnProperty(
                                            "rework_message"
                                          ) ? (
                                            <div>
                                              <h4>Rework</h4>
                                              <p>
                                                Rework Message :{" "}
                                                {item.rework_message}
                                              </p>
                                            </div>
                                          ) : null}

                                          {item.hasOwnProperty(
                                            "rework_salary_amount"
                                          ) ? (
                                            <div>
                                              <p>
                                                Rework Salary Amount :{" "}
                                                {item.rework_salary_amount}
                                              </p>
                                            </div>
                                          ) : null}
                                          {/* {item.event_starts<moment()<item.event_ends? */}

                                          <div className="float-end">
                                            {item.invitation_status !=
                                            "Unaccepted" ? (
                                              <>
                                                {/* item.task_type == "1" ? (
                                                  data.currently_working_regular ==
                                                  false ? (
                                                    item.task_status ==
                                                    "Paused" ? (
                                                      // moment().isBetween(item.event_starts,item.event_ends)&&
                                                      <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary  px-3 mb-2"
                                                        onClick={() => {
                                                          start(item.id);
                                                        }}
                                                      >
                                                        Resume
                                                      </button>
                                                    ) : (
                                                      // moment().isBetween(item.event_starts,item.event_ends)&&
                                                      <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary px-3 mb-2"
                                                        onClick={() => {
                                                          start(item.id);
                                                        }}
                                                      >
                                                        start
                                                      </button>
                                                    )
                                                  ) : (
                                                    ""
                                                  )
                                                ) : data.currently_working_hour ==
                                                  false ? (
                                                  item.task_status ==
                                                  "Paused" ? (
                                                    // moment().isBetween(item.event_starts,item.event_ends)&&
                                                    <button
                                                      type="button"
                                                      className="btn btn-sm btn-primary mb-2"
                                                      onClick={() => {
                                                        start(item.id);
                                                      }}
                                                    >
                                                      Resume
                                                    </button>
                                                  ) : (
                                                    // item.event_starts_timestamp <
                                                    curr_time <
                                                      item.event_ends_timestamp && (
                                                      <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary mb-2 "
                                                        onClick={() => {
                                                          start(item.id);
                                                        }}
                                                      >
                                                        start
                                                      </button>
                                                    )
                                                  )
                                                ) : (
                                                  ""
                                                ) */}
                                                {!data.currently_working_hour &&
                                                item.event_starts_timestamp <=
                                                  curr_time &&
                                                curr_time <=
                                                  item.event_ends_timestamp ? (
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary mb-2 "
                                                    onClick={() => {
                                                      start(item.id);
                                                    }}
                                                  >
                                                    Start
                                                  </button>
                                                ) : null}
                                              </>
                                            ) : (
                                              <>
                                                <p>Invitation Not Accepted</p>

                                                <button
                                                  type="button"
                                                  className="btn btn-primary mb-2 me-2 px-3 btn-sm"
                                                  onClick={() => {
                                                    accept_invite(item, index);
                                                  }}
                                                >
                                                  Accept
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn btn-danger mb-2 px-3 btn-sm"
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#rejectModal"
                                                  onClick={() => {
                                                    console.log(
                                                      "assign_task on reject :",
                                                      assign_task
                                                    );
                                                    // delete_service(data, s_index);
                                                    SetRejectModal(
                                                      (prevValue) => {
                                                        prevValue.is_open =
                                                          true;
                                                        prevValue.title =
                                                          "invitation";
                                                        prevValue.record = item;
                                                        prevValue.assign_task =
                                                          assign_task;
                                                        prevValue.index = index;
                                                        return { ...prevValue };
                                                      }
                                                    );
                                                  }}
                                                >
                                                  Reject
                                                </button>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : item.app_id == 3 ? (
                                    <div className="card-body">
                                      {/* <h5 className="card-title"> {item.company}</h5> */}
                                      {/* <h6 className="card-subtitle mb-2 text-muted">Card subtitle</h6> */}
                                      <div>
                                        <div className="card-text ">
                                          <div className="d-flex">
                                            <h5>{item.task}</h5>

                                            {/* <h5>({item.quantity})</h5> */}
                                            <div className="dropdown ms-auto">
                                              <div
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                              >
                                                <i className="fa-solid fa-ellipsis"></i>
                                              </div>
                                              <ul
                                                className="dropdown-menu"
                                                aria-labelledby="dropdownMenuButton1"
                                              >
                                                {/* Files */}
                                                <li>
                                                  <button
                                                    className="dropdown-item"
                                                    type="button"
                                                    onClick={() => {
                                                      // delete_service(data, s_index);
                                                      SetFileModal(
                                                        (prevValue) => {
                                                          prevValue.is_open =
                                                            true;
                                                          prevValue.title =
                                                            "Files";
                                                          prevValue.record =
                                                            item.hasOwnProperty(
                                                              "files"
                                                            )
                                                              ? item.files
                                                              : [];
                                                          prevValue.index =
                                                            index;
                                                          return {
                                                            ...prevValue,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  >
                                                    Files
                                                  </button>
                                                </li>
                                                {/* Editor field */}
                                                {/* {item.hasOwnProperty("edited_files") ? ( */}
                                                <li>
                                                  <button
                                                    className="dropdown-item"
                                                    type="button"
                                                    onClick={() => {
                                                      // delete_service(data, s_index);
                                                      SetEditorModal(
                                                        (prevValue) => {
                                                          prevValue.is_open =
                                                            true;
                                                          prevValue.title =
                                                            "Editor field";
                                                          prevValue.record =
                                                            item.hasOwnProperty(
                                                              "edited_files"
                                                            )
                                                              ? item.edited_files
                                                              : [];
                                                          prevValue.index =
                                                            index;
                                                          return {
                                                            ...prevValue,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  >
                                                    Editor field
                                                  </button>
                                                </li>
                                                {/* ) : null} */}

                                                {/* Notes */}
                                                <li>
                                                  <button
                                                    className="dropdown-item"
                                                    type="button"
                                                    onClick={() => {
                                                      // delete_service(data, s_index);
                                                      SetNoteModal(
                                                        (prevValue) => {
                                                          prevValue.is_open =
                                                            true;
                                                          prevValue.title =
                                                            "Notes";
                                                          prevValue.record =
                                                            item.hasOwnProperty(
                                                              "notes"
                                                            )
                                                              ? item.notes
                                                              : [];
                                                          prevValue.index =
                                                            index;
                                                          return {
                                                            ...prevValue,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  >
                                                    Notes
                                                  </button>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <div className="d-flex">
                                            <div>
                                              <h6 className="text-muted">
                                                Service : {item.service_name}
                                              </h6>
                                              <h6>{item.event_name}</h6>
                                            </div>
                                            <div className="ms-auto text-center">
                                              <div className="d-flex">
                                                <div className="fs-14">
                                                  {item.quantity}
                                                </div>
                                                <div className="ms-1">Qty</div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex">
                                            <h6>
                                              Customer : {item.customer_name}
                                            </h6>
                                            {item.max_working_hours && (
                                              <div className="ms-auto">
                                                max time :
                                                {item.max_working_hours} hrs
                                              </div>
                                            )}
                                          </div>
                                          <div className="d-flex">
                                            <h6>
                                              File Name : {item.client_name}
                                            </h6>
                                            {item.hasOwnProperty(
                                              "remaining_duration"
                                            ) ? (
                                              <div className="ms-auto">
                                                remaining duration :
                                                {secondsToHms(
                                                  item.remaining_duration
                                                )}
                                              </div>
                                            ) : null}
                                          </div>
                                          <div className="d-flex">
                                            <div className="text-muted">
                                              {item.created_at}
                                            </div>
                                            <div className="ms-auto">
                                              {item.hasOwnProperty(
                                                "rework_message"
                                              ) ? (
                                                <div>
                                                  <h4>Rework</h4>
                                                  <p>
                                                    Rework Message :{" "}
                                                    {item.rework_message}
                                                  </p>
                                                </div>
                                              ) : null}

                                              {item.hasOwnProperty(
                                                "rework_salary_amount"
                                              ) ? (
                                                <div>
                                                  <p>
                                                    Rework Salary Amount :{" "}
                                                    {item.rework_salary_amount}
                                                  </p>
                                                </div>
                                              ) : null}

                                              {/* Photo Album */}
                                              <div className="float-end">
                                                {item.invitation_status !=
                                                "Unaccepted" ? (
                                                  <>
                                                    {!data.currently_working_regular ? (
                                                      item.hasOwnProperty(
                                                        "max_working_hours"
                                                      ) ? (
                                                        parseFloat(
                                                          item.max_working_hours
                                                        ) > 0 &&
                                                        item.hasOwnProperty(
                                                          "remaining_duration"
                                                        ) &&
                                                        parseFloat(
                                                          item.remaining_duration
                                                        ) > 0 ? (
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary mb-2 "
                                                            onClick={() => {
                                                              start(item.id);
                                                            }}
                                                          >
                                                            {item.task_status ==
                                                            "Paused"
                                                              ? "Resume"
                                                              : "Start"}
                                                          </button>
                                                        ) : null
                                                      ) : (
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm btn-primary mb-2 "
                                                          onClick={() => {
                                                            start(item.id);
                                                          }}
                                                        >
                                                          {item.task_status ==
                                                          "Paused"
                                                            ? "Resume"
                                                            : "Start"}
                                                        </button>
                                                      )
                                                    ) : null}
                                                  </>
                                                ) : (
                                                  <>
                                                    <p>
                                                      Invitation Not Accepted
                                                    </p>

                                                    <button
                                                      type="button"
                                                      className="btn btn-primary mb-2 px-3 btn-sm"
                                                      onClick={() => {
                                                        accept_invite(
                                                          item,
                                                          index
                                                        );
                                                      }}
                                                    >
                                                      Accept
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn btn-danger mb-2 px-3 btn-sm ms-2"
                                                      data-bs-toggle="modal"
                                                      data-bs-target="#rejectModal"
                                                      onClick={() => {
                                                        console.log(
                                                          "assign_task on reject :",
                                                          assign_task
                                                        );
                                                        // delete_service(data, s_index);
                                                        SetRejectModal(
                                                          (prevValue) => {
                                                            prevValue.is_open =
                                                              true;
                                                            prevValue.title =
                                                              "invitation";
                                                            prevValue.record =
                                                              item;
                                                            prevValue.assign_task =
                                                              assign_task;
                                                            prevValue.index =
                                                              index;
                                                            return {
                                                              ...prevValue,
                                                            };
                                                          }
                                                        );
                                                      }}
                                                    >
                                                      Reject
                                                    </button>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          )
                      )
                    : null}
                </div>
              </>
            </div>
          </div>

          {next_page ? (
            <div className="text-center mt-3 mb-3">
              <button
                type="button"
                className="load btn btn-primary px-3 "
                onClick={() => {
                  // SetPageNo(page_no + 1);
                  get_Assign_task(company_id, true, page_no);
                }}
              >
                <b>Load More</b>
              </button>
            </div>
          ) : (
            ""
          )}
        </div>

        <div
          className="tab-pane fade"
          id="history-tasks"
          role="tabpanel"
          aria-labelledby="deleted-users-tab"
        >
          <div className="container">
            {historyVal?.map((item: any, index: any) =>
              item.app_id == 2 ? (
                <div className="box-2 p-3 br-3 mb-2 col-lg-8 mx-auto">
                  <div className="d-flex">
                    <div>
                      <div className="f-14">{item.service_name}</div>

                      <div>
                        <h6>{item.event_name}</h6>
                      </div>

                      {item.event_starts && (
                        <p className="text-muted">
                          <i className="fa-regular fa-clock"></i>{" "}
                          {item.event_starts} to {item.event_ends}
                        </p>
                      )}
                      {/* <h5>({item.quantity})</h5> */}

                      {item.event_venue && <div>Venue: {item.event_venue}</div>}
                      {item.event_location && (
                        <div>
                          <i className="fa-solid fa-location-dot"></i>{" "}
                          {item.event_location}
                        </div>
                      )}

                      {item.client_name && (
                        <h6>Client Name : {item.client_name}</h6>
                      )}
                    </div>

                    {item.event_latitude && item.event_longitude ? (
                      <div className="ms-lg-auto">
                        <div className="text-center">
                          <a
                            target="_blank"
                            href={
                              "https://www.google.com/maps/search/?api=1&query=" +
                              item.event_latitude +
                              "%2C" +
                              item.event_longitude
                            }
                          >
                            <i className="fas fa-directions fs-38"></i>
                            <div className="text-uppercase mt-1 fs-12">
                              Get Directions
                            </div>
                          </a>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div>Exposure pay : {item.amount}</div>

                  {item.hasOwnProperty("rework_message") ? (
                    <div>
                      <h4>Rework</h4>
                      <p>Rework Message : {item.rework_message}</p>
                    </div>
                  ) : null}

                  {item.hasOwnProperty("rework_salary_amount") ? (
                    <div>
                      <p>Rework Salary Amount : {item.rework_salary_amount}</p>
                    </div>
                  ) : null}

                  <div className="d-flex">
                    <div className="text-muted">{item.created_at}</div>
                    <span className="badge bg-primary ms-auto">
                      {item.task_status}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="box-2 p-3 br-3 mb-2 col-lg-8 mx-auto">
                  <div className="container">
                    <div className="d-flex">
                      <div>
                        <h5>{item.task}</h5>
                        <h6>Sevrice : {item.service_name}</h6>
                      </div>
                      <div className="ms-auto text-center">
                        <div className="d-flex">
                          <div className="fs-14">{item.quantity}</div>
                          <div className="ms-1">Qty</div>
                        </div>
                        {item.max_working_hours && (
                          <div>max time :{item.max_working_hours} hrs</div>
                        )}
                      </div>
                    </div>
                    <h6>{item.event_name}</h6>
                    <h6>Customer : {item.customer_name}</h6>
                    <h6>File Name : {item.client_name}</h6>
                    {item.hasOwnProperty("final_quantity") ? (
                      <p>Finished Quantity : {item.final_quantity}</p>
                    ) : null}
                    {item.hasOwnProperty("salary_amount") ? (
                      <p>Salary Amount : {item.salary_amount}</p>
                    ) : null}
                    <div className="d-flex">
                      <div className="text-muted">
                        {" "}
                        {moment(item.created_at).fromNow()}
                      </div>
                      <div className="ms-auto">
                        <div className="col card-text">
                          <span className="badge bg-primary">
                            {item.task_status}
                          </span>
                        </div>
                      </div>
                      {/* {item.status == "Accepted" && (
                       <span className="badge bg-primary">Accepted</span>
                     )}

                     {item.status == "Rejected" && (
                       <span className="badge bg-danger">Rejected</span>
                     )}

                     {item.status == "Deleted" && (
                       <span className="badge bg-danger">Deleted</span>
                     )} */}

                      {/* {item.status == null && (
                       <>
                         <button
                           type="button"
                           className="btn btn-primary m-2"
                           onClick={() => {
                             accept_invite(item, index);
                           }}
                         >
                           Accept
                         </button>
                         <button
                           type="button"
                           className="btn btn-danger m-2"
                           data-bs-toggle="modal"
                           data-bs-target="#exampleModal"
                           onClick={() => {
                             // delete_service(data, s_index);
                             SetRejectModal((prevValue) => {
                               prevValue.is_open = true;
                               prevValue.title = "invitation";
                               prevValue.record = item.id;
                               prevValue.index = index;
                               return { ...prevValue };
                             });
                           }}
                         >
                           Reject
                         </button>
                       </>
                     )} */}
                    </div>
                    &nbsp;
                  </div>
                </div>
              )
            )}
          </div>
          {next_page ? (
            <div className="text-center mt-3 mb-3">
              <button
                type="button"
                className="load btn btn-primary px-3 "
                onClick={() => {
                  get_history(company_id);
                }}
              >
                <b>Load More</b>
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* ) : (
        <h5>No task assigned</h5>
      )} */}

      {/* <!-- Modal --> */}

      <FileAlert
        open={file_modal.is_open}
        title={file_modal.title}
        record={file_modal.record}
        index={file_modal.index}
        close={(data) => {
          SetFileModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
        }}
      />

      <NoteAlert
        open={note_modal.is_open}
        title={note_modal.title}
        record={note_modal.record}
        index={note_modal.index}
        close={(data) => {
          SetNoteModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
        }}
      />

      <EditorAlert
        open={editor_modal.is_open}
        title={editor_modal.title}
        record={editor_modal.record}
        index={editor_modal.index}
        close={(data) => {
          SetEditorModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
        }}
      />

      <RejectAlert
        open={reject_modal.is_open}
        title={reject_modal.title}
        record={reject_modal.record}
        assign_task={reject_modal.assign_task}
        index={reject_modal.index}
        close={(data) => {
          console.log("RejectAlert on close data ", data);
          SetRejectModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete Service : ", data);

            console.log("RejectAlert on close assign_task :", assign_task);

            reject_invite(data.value, data.index, data.assign_task);
          }
        }}
      />
    </div>
  );
}
